export default "__VITE_ASSET__f9783ed4__"